import { eLayoutType, RoutesService } from '@abp/ng.core';
import { APP_INITIALIZER } from '@angular/core';

export const EVENT_SLOTS_EVENT_SLOT_ROUTE_PROVIDER = [
  { provide: APP_INITIALIZER, useFactory: configureRoutes, deps: [RoutesService], multi: true },
];

function configureRoutes(routes: RoutesService) {
  return () => {
    routes.add([
      {
        path: '/event-slots',
        iconClass: 'fas fa-clock',
        name: '::Menu:EventSlots',
        layout: eLayoutType.application,
        requiredPolicy: 'Mandir.EventSlots',
      },
    ]);
  };
}
